module.exports = __webpack_public_path__ + "static/media/doupleCircle.0cd4904e.svg";